// ================================================================
// Gesprächsrunde des Assistenten — «hat der MENSCH dazwischen geredet?»
// ================================================================
// Der Schlüssel wechselt genau dann, wenn der Nutzer etwas gesagt oder
// getippt hat, und bleibt über alle Werkzeugaufrufe einer Runde gleich.
// Er reist als ui_context.turn_key mit; der Server lässt eine Zustimmung
// zum Versand nur gelten, wenn sie aus einer SPÄTEREN Runde kommt als der
// Vorschlag — sonst hätte das Modell sich selbst bestätigt.
// Gegenstück: backend/src/modules/voice/outbound-confirm.service.ts.
//
// Warum hier in core und nicht in der AssistantBar-Engine: auch Ansichten
// lesen ihn (das Sende-Sheet meldet, seit WELCHER Runde es offen ist), und
// die sollen dafür nicht die Engine importieren müssen.

function newTurnKey(): string {
  // crypto.randomUUID fehlt in älteren WebViews und in unsicheren Kontexten.
  // Der Wert muss nur je Runde verschieden und nicht erratbar sein.
  try {
    if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
      return crypto.randomUUID().replace(/-/g, '');
    }
  } catch { /* Fallback unten */ }
  return Math.random().toString(36).slice(2) + Date.now().toString(36);
}

let turnKey = newTurnKey();

/** Schlüssel der laufenden Runde. */
export function getTurnKey(): string { return turnKey; }

/** Neue Runde beginnen — nach jeder abgeschlossenen Nutzer-Äusserung. */
export function startTurn(): string {
  turnKey = newTurnKey();
  return turnKey;
}
